import {register} from '@shopify/theme-sections'
import '../../styles/sections/section-metaobject-landing.scss'

export default register(`section-metaobject-landing`, {
    onLoad() {
    },
    onUnload() {

    },
})
